














import { defineComponent, PropType } from '@vue/composition-api'
import MissionHexagonCircuitParts from '@/components/MissionPage/MissionListPane/parts/MissionHexagonCircuitParts.vue'
import { MissionProgressCardType } from '@/components/MissionPage/hook/useMissionProgressData'

export default defineComponent({
  name: 'MissionHoneyCombCircuitParts',
  props: {
    mission: {
      type: Object as PropType<MissionProgressCardType>,
      required: true,
    },
  },
  components: {
    MissionHexagonCircuitParts,
  },
  setup() {
    return {}
  },
})
